import { render } from "./EditLiquidation4.vue?vue&type=template&id=0ebdf9b6"
import script from "./EditLiquidation4.vue?vue&type=script&lang=js"
export * from "./EditLiquidation4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__